"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateQuickAmount = void 0;
const react_1 = require("react");
const constants_1 = require("./constants");
const useUpdateQuickAmountsSettings_1 = require("./useUpdateQuickAmountsSettings");
const utils_1 = require("./utils");
const useUpdateQuickAmount = ({ type, settings, minValue, maxValue, }) => {
    const [error, setError] = (0, react_1.useState)(null);
    const { updateQuickAmountsSettings, isLoading } = (0, useUpdateQuickAmountsSettings_1.useUpdateQuickAmountsSettings)();
    const amounts = (0, react_1.useMemo)(() => {
        var _a;
        const key = constants_1.quickAmountsByType[type];
        return (_a = settings[key]) !== null && _a !== void 0 ? _a : [];
    }, [settings, type]);
    const updateAmounts = (0, react_1.useCallback)((updatedAmounts) => {
        const key = constants_1.quickAmountsByType[type];
        const quickAmounts = { ...settings, [key]: updatedAmounts };
        updateQuickAmountsSettings(quickAmounts);
    }, [settings, type, updateQuickAmountsSettings]);
    const addAmount = (0, react_1.useCallback)((amount) => {
        const updatedAmounts = [...amounts, amount];
        const error = (0, utils_1.validateQuickAmount)(amount, minValue, updatedAmounts.length, maxValue);
        if (error) {
            setError(error);
            return;
        }
        setError(null);
        updateAmounts(updatedAmounts);
    }, [amounts, maxValue, minValue, updateAmounts]);
    const removeAmount = (0, react_1.useCallback)((index) => {
        const updatedAmounts = amounts.filter((_, i) => i !== index);
        updateAmounts(updatedAmounts);
    }, [amounts, updateAmounts]);
    const setAmountType = (0, react_1.useCallback)(() => {
        updateQuickAmountsSettings({
            ...settings,
            quickAmountsType: type,
        });
    }, [settings, type, updateQuickAmountsSettings]);
    return (0, react_1.useMemo)(() => ({
        error,
        isLoading,
        addAmount,
        setAmountType,
        removeAmount,
    }), [error, isLoading, addAmount, setAmountType, removeAmount]);
};
exports.useUpdateQuickAmount = useUpdateQuickAmount;
//# sourceMappingURL=useUpdateQuickAmount.js.map